import { render, staticRenderFns } from "./RealNameAuth.vue?vue&type=template&id=65226d36&scoped=true&"
import script from "./RealNameAuth.vue?vue&type=script&lang=js&"
export * from "./RealNameAuth.vue?vue&type=script&lang=js&"
import style0 from "./RealNameAuth.vue?vue&type=style&index=0&id=65226d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65226d36",
  null
  
)

export default component.exports